import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../Button/Button";
import { Icon } from "../Icon/Icon";
import { Logo } from "../Logo/Logo";
import {ReactSession} from "../../../../lib/secure_reactsession";
import { getTesterAccountDetails } from "../../../../services/user";
import { roundNumber } from "../../../../lib/helpers";

import Skeleton from "react-loading-skeleton";
import { Tooltip } from "../Tooltip/Tooltip";

export const TakingTestHeader = ({exitText,test,isRecording}) => {

    const navigate = useNavigate();
    
    let user = ReactSession.get("user");
    
    const [menuClass, setMenuClass] = useState('');

    const [testerscore, setTesterScore] = useState(null);
    const [scoreLoading, setScoreLoading] = useState(false);
    const [isScreenRecordingEnable,setIsScreenRecordingEnable] = useState(false);

    const getAccountDetails =()=>{

        setScoreLoading(true);
        
        const token = ReactSession.get("token");
        
        getTesterAccountDetails(token).then(response=> {

            if(response.success){
              
                setTesterScore(response.score);
                ReactSession.set("testerscore", response.score.toString());
                ReactSession.set("accountstatus", response.account_status);
                
            }
            setScoreLoading(false);
        });
        

    }
    useEffect(()=>{
        let user = ReactSession.get("user");
        if (user) {
            getAccountDetails();
        }
      

        
    },[])
    return (
        <>
        <div className="header researcher-header taking-test-header">
            <div className="container">
                <div className="header-inner-data body-text body-text body-text-2 medium-font none-for-mobile">
                    <div className="header-lhs-side">
                        <div className="logo">
                            <Link to={"/"} target={isRecording ? "_blank" : "_self"}>
                                <Logo theme={"white"} background={"black"} />
                            </Link>
                        </div>

                    </div>

                    <div className="header-rhs-side">



                        <div className="header-credits-wrap">
                            {user && user.role=="Tester" &&
                            <span className={`header-link credits-link-header score-link-header ${testerscore>80 ? "green-star":""} ${60<testerscore && testerscore<=80 ? "purple-star":""} ${50<testerscore && testerscore<=60 ? "yellow-star":""} ${testerscore<=50 && testerscore!=null  ? "red-star":""} ${testerscore==null?"white-star":""}`}>
                                <div className="score-star-icon">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.3067 4.66529C15.3631 4.52774 15.4591 4.41006 15.5826 4.32724C15.706 4.24442 15.8513 4.2002 16 4.2002C16.1487 4.2002 16.294 4.24442 16.4174 4.32724C16.5409 4.41006 16.6369 4.52774 16.6933 4.66529L19.5267 11.48C19.5797 11.6075 19.6669 11.7179 19.7786 11.799C19.8904 11.8802 20.0223 11.929 20.16 11.94L27.5173 12.5293C28.1827 12.5826 28.452 13.4133 27.9453 13.8466L22.34 18.6493C22.2353 18.7389 22.1572 18.8556 22.1144 18.9866C22.0716 19.1176 22.0657 19.2578 22.0973 19.392L23.8107 26.572C23.8451 26.716 23.8361 26.867 23.7847 27.006C23.7334 27.1449 23.642 27.2655 23.5222 27.3525C23.4023 27.4395 23.2594 27.4891 23.1114 27.4949C22.9634 27.5008 22.817 27.4626 22.6907 27.3853L16.3907 23.5386C16.273 23.4669 16.1378 23.429 16 23.429C15.8622 23.429 15.727 23.4669 15.6093 23.5386L9.30933 27.3866C9.18301 27.464 9.03661 27.5021 8.88861 27.4963C8.74061 27.4904 8.59767 27.4409 8.47782 27.3538C8.35798 27.2668 8.26662 27.1462 8.21527 27.0073C8.16392 26.8684 8.1549 26.7173 8.18933 26.5733L9.90267 19.392C9.93444 19.2578 9.9286 19.1175 9.88579 18.9865C9.84297 18.8555 9.76485 18.7388 9.66 18.6493L4.05467 13.8466C3.94242 13.7501 3.86121 13.6226 3.82127 13.48C3.78132 13.3375 3.78441 13.1863 3.83015 13.0455C3.8759 12.9047 3.96225 12.7806 4.07835 12.6887C4.19446 12.5969 4.33512 12.5414 4.48267 12.5293L11.84 11.94C11.9777 11.929 12.1096 11.8802 12.2214 11.799C12.3331 11.7179 12.4203 11.6075 12.4733 11.48L15.3067 4.66529Z" stroke="#BFF0A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                </div>
                                {!scoreLoading &&
                                <>{roundNumber(testerscore, 0)}%</>
                                }
                                {scoreLoading &&
                                <><Skeleton className="header-credit-skeleton" width={30} height={14}/></>
                                }
                                <Tooltip
                                type={"top"}
                                data={<>
                                    Your score has been calculated based on your performance in the tests, considering your answers and overall actions. Want to know more about our scoring system? Check out the <a href={process.env.REACT_APP_URL+"t/tester-guidelines"} target="_blank" className="tooltip-guidelines">guidelines</a> for all the details you need. 
                                </>}
                            />
                            </span>
                            }
                            {user ?
                            <span className="d-flex logged-in-user-info align-center">
                                <Icon value={"profile"} colorClass="gray-50-svg" size={"large"}/>
                                {user.first_name}</span>
                            :
                            <Button
                                onClick={()=>{
                                    if(isRecording){
                                        window.open('/tester/login', '_blank');
                                    }else{
                                    navigate('/tester/login');
                                    }
                                }}
                                type={"ghost"}
                                size={"small"}
                                label={test && test.language=="ar"?<>تسجيل الدخول</>:<>Login</>}
                            />
                            }   
                            {user && user.role == "Tester" ?
                                <Button onClick={()=>{ navigate('/t/support/contact?reason=Problem with the platform'); }} type={"ghost"} size={"small"}  label={test.language=="ar"?<>اتصل بالدعم</>:<>Contact support</>} />
                                :
                                <>
                                    {user && user.role == "Researcher" ?
                                            <Button
                                            onClick={() => {
                                                navigate('/r/support/contact');
                                            }} type={"ghost"} size={"small"}
                                                    label={test && test.language == "ar" ? <>اتصل بالدعم</> : <>Contact
                                                        support</>}/>
                                        :
                                            <a href={'https://userq.com/contact-us/'} target={"_blank"}>
                                                <Button
                                                 target={isRecording ? "_blank" : "_self"}
                                                onClick={() => {
                                                }} type={"ghost"} size={"small"}
                                                        label={test && test.language == "ar" ? <>اتصل بالدعم</> : <>Contact
                                                            support</>}/>
                                            </a>
                                    }
                                </>
                            }

                            <Button
                                onClick={()=>{
                                    if(exitText)
                                        exitText()
                                }}
                                type={"ghost"}
                                size={"small"}
                                iconRight={<Icon colorClass="gray-50-svg forwardarrow-icon" size={"small"} value={test && test.language=="ar"?'Back arrow':'Forward arrow'}/>}
                                label={test && test.language=="ar"?<>اخرج</>:<>Exit test</>}
                            />


                        </div>
                    </div>
                </div>
                <div className="header-for-mobile none-for-desktop">
                    <div className="mobile-header-top">
                        <div className="logo">
                            <Link to={"/"} >
                                <Logo theme={"white"} background={"black"} />
                            </Link>
                        </div>
                        <div className="mobile-menu-wrap">
                            <span className="open-m-menu" onClick={()=>{setMenuClass("open-menu"); document.body.classList.add('open-m-menu'); }}>
                                <Icon colorClass="gray-50-svg close-icon" size={'large'} value={'menu'}/>
                            </span>
                        </div>
                    </div>
                    <div className={`m-nagivation-wrap ${menuClass}`}>
                        <div className="mobile-header-top">
                            <div className="logo">
                                <Link to={"/"} >
                                    <img src={process.env.REACT_APP_URL+"img/UQ.svg"} alt="UserQ"/>
                                </Link>
                            </div>
                            <div className="mobile-menu-wrap">
                                <span className="close-m-menu" onClick={()=>{setMenuClass(""); document.body.classList.remove('open-m-menu');}}>
                                    <Icon colorClass="gray-50-svg close-icon" size={'large'} value={'close'}/>
                                </span>
                            </div>
                        </div>

                        {/*<div className="header-workspaceheading">*/}
                        {/*    Tester*/}
                        {/*</div>*/}


                        <div className="">
                            <div className="supportnavigationbox navigation-listing">
                                <ul>
                                    {user &&
                                    <li>
                                        <div className="header-workspaceheading">
                                            {user.first_name}

                                        </div>
                                    </li>
                                    }
                                    {user && user.role=="Tester" &&
                                    <li>
                                        <span className={`header-link credits-link-header score-link-header ${testerscore>80 ? "green-star":""} ${60<testerscore && testerscore<=80 ? "purple-star":""} ${50<testerscore && testerscore<=60 ? "yellow-star":""} ${testerscore<=50 && testerscore!=null  ? "red-star":""} ${testerscore==null?"white-star":""}`}>
                                            <div className="score-star-icon">
                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.3067 4.66529C15.3631 4.52774 15.4591 4.41006 15.5826 4.32724C15.706 4.24442 15.8513 4.2002 16 4.2002C16.1487 4.2002 16.294 4.24442 16.4174 4.32724C16.5409 4.41006 16.6369 4.52774 16.6933 4.66529L19.5267 11.48C19.5797 11.6075 19.6669 11.7179 19.7786 11.799C19.8904 11.8802 20.0223 11.929 20.16 11.94L27.5173 12.5293C28.1827 12.5826 28.452 13.4133 27.9453 13.8466L22.34 18.6493C22.2353 18.7389 22.1572 18.8556 22.1144 18.9866C22.0716 19.1176 22.0657 19.2578 22.0973 19.392L23.8107 26.572C23.8451 26.716 23.8361 26.867 23.7847 27.006C23.7334 27.1449 23.642 27.2655 23.5222 27.3525C23.4023 27.4395 23.2594 27.4891 23.1114 27.4949C22.9634 27.5008 22.817 27.4626 22.6907 27.3853L16.3907 23.5386C16.273 23.4669 16.1378 23.429 16 23.429C15.8622 23.429 15.727 23.4669 15.6093 23.5386L9.30933 27.3866C9.18301 27.464 9.03661 27.5021 8.88861 27.4963C8.74061 27.4904 8.59767 27.4409 8.47782 27.3538C8.35798 27.2668 8.26662 27.1462 8.21527 27.0073C8.16392 26.8684 8.1549 26.7173 8.18933 26.5733L9.90267 19.392C9.93444 19.2578 9.9286 19.1175 9.88579 18.9865C9.84297 18.8555 9.76485 18.7388 9.66 18.6493L4.05467 13.8466C3.94242 13.7501 3.86121 13.6226 3.82127 13.48C3.78132 13.3375 3.78441 13.1863 3.83015 13.0455C3.8759 12.9047 3.96225 12.7806 4.07835 12.6887C4.19446 12.5969 4.33512 12.5414 4.48267 12.5293L11.84 11.94C11.9777 11.929 12.1096 11.8802 12.2214 11.799C12.3331 11.7179 12.4203 11.6075 12.4733 11.48L15.3067 4.66529Z" stroke="#BFF0A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                            {!scoreLoading &&
                                            <>{roundNumber(testerscore, 2)}%</>
                                            }
                                            {scoreLoading &&
                                            <><Skeleton className="header-credit-skeleton" width={30} height={14}/></>
                                            }
                                            <Tooltip
                                                type={"top"}
                                                data={<>
                                                    This score has been calculated based on your performance including your answers and overall actions during the test. Check the <a href={process.env.REACT_APP_URL+"t/support"} target="_blank" className="tooltip-guidelines">guidelines</a> to know more about the score rating system. 
                                                </>}
                                            />
                                        </span>
                                    </li>
                                    }
                                    {user ?
                                    <li>
                                        <Link to={"/t/profile"}>
                                            <Icon colorClass="gray-600-svg profile-icon" size={"medium"} value={"profile"}/>

                                            <span> Your profile </span>
                                        </Link>
                                    </li>
                                    :
                                    <li>
                                        <Link to={"/tester/sign-in"} target={isRecording ? "_blank" : "_self"} >
                                            <Icon colorClass="gray-600-svg profile-icon" size={"medium"} value={"profile"}/>

                                            <span> {test && test.language=="ar"?<>تسجيل الدخول</>:<>Login</>} </span>
                                        </Link>
                                    </li>
                                    }
                                    <li>
                                            {user && user.role == "Tester" ?
                                                <Link to={"/t/support/contact?reason=Problem with the platform"}>
                                                <Icon colorClass="gray-600-svg support-icon" value={'support'}/>

                                                <span>{test && test.language=="ar"?<>اتصل بالدعم</>:<>Contact support</>} </span>
                                            </Link>
                                            :
                                            <a href={'https://userq.com/contact-us/'}  target="_blank">
                                                <Icon colorClass="gray-600-svg support-icon" value={'support'}/>
                                                <span> {test && test.language=="ar"?<>اتصل بالدعم</>:<>Contact support</>}</span>
                                            </a>
                                        }

                                    </li>
                                </ul>
                            </div>  

                            <div className="bottomnavigationlist navigation-listing">
                                <ul>
                                    <li>
                                        <a href="#" onClick={()=>{
                                        if(exitText)
                                        exitText()
                                    }}>{test && test.language=="ar"?<>اخرج</>:<>Exit test</>}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>






                    </div>
                </div>
            </div>
        </div>
        </>
    );
};